// // ========== Configuration ==========
// const ENABLE_LOGGING = false;
// const API_BASE_URL = "https://copy-lead.marke-ter.online/api/segment"; // Your Laravel API base URL

// // ========== Logging Helper ==========
// function log(...args) {
//   if (ENABLE_LOGGING) {
//     console.log("[SEGMENT TRACKER]", ...args);
//   }
// }

// // ========== API Functions ==========
// function segmentIdentify(userId, traits) {
//   return new Promise((resolve, reject) => {
//     log("Making Segment Identify API call for:", userId);
    
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("X-CSRF-TOKEN", document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')); // For Laravel CSRF protection
    
//     const raw = JSON.stringify({
//       userId: userId,
//       traits: traits
//     });
    
//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "manual"
//     };
    
//     fetch(`${API_BASE_URL}/identify`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         log("Identify API response:", result);
//         resolve(result);
//       })
//       .catch((error) => {
//         console.error("Identify API error:", error);
//         reject(error);
//       });
//   });
// }

// function segmentTrack(userId, event, properties) {
//   return new Promise((resolve, reject) => {
//     log("Making Segment Track API call for event:", event);
    
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("X-CSRF-TOKEN", document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')); // For Laravel CSRF protection
    
//     const raw = JSON.stringify({
//       userId: userId,
//       event: event,
//       properties: properties
//     });
    
//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "manual"
//     };
    
//     fetch(`${API_BASE_URL}/track`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         log("Track API response:", result);
//         resolve(result);
//       })
//       .catch((error) => {
//         console.error("Track API error:", error);
//         reject(error);
//       });
//   });
// }

// // ========== Helpers ==========
// function getSegmentData() {
//   log("Getting segment data from localStorage");
//   return JSON.parse(localStorage.getItem("segment_data"));
// }

// function saveSegmentData(data) {
//   log("Saving segment data to localStorage");
//   localStorage.setItem("segment_data", JSON.stringify(data));
// }

// function shouldTrackView(segmentData, location) {
//   return segmentData?.email && location?.toLowerCase() !== "pappikistan";
// }

// function updateViewCount(segmentData) {
//   segmentData.pageViewCount = (segmentData.pageViewCount || 0) + 1;
//   saveSegmentData(segmentData);
//   return segmentData.pageViewCount;
// }

// async function identifyUser(segmentData) {
//   log("Identifying user:", segmentData.email);
  
//   // Call identify API and wait for it to complete
//   try {
//     await segmentIdentify(segmentData.email, {
//       email: segmentData.email,
//       name: segmentData.name,
//       phone: segmentData.phone,
//       sign_type_interested: segmentData.signType || segmentData.sign_type
//     });
//     log("User identification completed successfully");
//     return true;
//   } catch (error) {
//     log("User identification failed:", error);
//     return false;
//   }
// }

// // ========== Track Events ==========
// async function trackFormSubmitted(formData) {
//   log("Step 1: Form submitted, starting tracking process");
  
//   // Step 2: Create and save segment data
//   const segmentData = {
//     name: formData.name,
//     email: formData.email,
//     phone: formData.phone,
//     sign_type: formData.signType || "3d Acrylic Sign",
//   };
//   saveSegmentData(segmentData);
//   log("Step 2: Segment data saved to localStorage");
  
//   // Step 3: Identify the user and wait for it to complete
//   log("Step 3: Starting user identification");
//   const identifySuccess = await identifyUser(segmentData);
  
//   if (identifySuccess) {
//     // Step 4: Track the form submission event only after identify is complete
//     log("Step 4: Tracking form submission event");
//     try {
//       await segmentTrack(segmentData.email, "Form Submitted", {
//         sign_type: segmentData.sign_type,
//         logo_url: formData.logo_url || "",
//         details: formData.details || "",
//         mockup_types_selected: formData.mockup_types_selected || ""
//       });
//       log("Step 5: Form tracking process complete");
//       return true;
//     } catch (error) {
//       log("Error tracking form submission:", error);
//       return false;
//     }
//   } else {
//     log("Step 4: Form tracking skipped due to identification failure");
//     return false;
//   }
// }

// async function trackPaymentView(productId, productPrice) {
//   log("Step 1: Payment view tracking initiated");
  
//   // Step 2: Get data
//   const segmentData = getSegmentData();
//   const location = localStorage.getItem("countryName");
//   log("Step 2: Retrieved segment data and location");

//   // Ensure `segmentData` is available and `location` is retrieved correctly
//   if (!segmentData || !location) {
//     log("Error: Missing segment data or location");
//     return false;
//   }
  
//   // Step 3: Check if we should track
//   if (shouldTrackView(segmentData, location)) {
//     log("Step 3: Verification passed, proceeding with tracking");
    
//     // Step 4: Update view count
//     const viewCount = updateViewCount(segmentData);
//     log("Step 4: View count updated to", viewCount);
    
//     // Step 5: Identify user first and wait for completion
//     log("Step 5: Starting user identification");
//     const identifySuccess = await identifyUser(segmentData);
    
//     if (identifySuccess) {
//       // Step 6: Track the view event only after identify is complete
//       log("Step 6: Tracking payment view event");
      
//       if (!productId || !productPrice) {
//         log("Error: Missing product information");
//         return false;
//       }
      
//       try {
//         await segmentTrack(segmentData.email, "Payment Link Viewed", {
//           sign_type: segmentData.sign_type,
//           payment_link_id: productId,
//           shopify_url: window.location.href,
//           price: productPrice,
//           viewed_on_device: window.innerWidth < 768 ? "mobile" : "desktop",
//           view_count: viewCount
//         });
        
//         log("Step 7: Payment view tracking process complete");
//         return true;
//       } catch (error) {
//         log("Error tracking payment view:", error);
//         return false;
//       }
//     } else {
//       log("Step 6: Payment view tracking skipped due to identification failure");
//       return false;
//     }
//   } else {
//     log("Step 3: Verification failed, tracking skipped");
//     return false;
//   }
// }






// ##################### USING ANAYLYTICS.JS ##############################

// ========== Configuration ==========
const ENABLE_LOGGING = true;

// ========== Logging Helper ==========
function log(...args) {
  if (ENABLE_LOGGING) {
    console.log("[SEGMENT TRACKER]", ...args);
  }
}

// ========== Helpers ==========
function getSegmentData() {
  log("Getting segment data from localStorage");
  const data = JSON.parse(localStorage.getItem("segment_data"));
  log("Retrieved segment data:", data);
  return data;
}

function saveSegmentData(data) {
  log("Saving segment data to localStorage:", data);
  localStorage.setItem("segment_data", JSON.stringify(data));
}

function shouldTrackView(segmentData, location) {
  const shouldTrack = segmentData?.email && location?.toLowerCase() !== "pakistan";
  log("Should track view?", shouldTrack, {
    hasEmail: !!segmentData?.email,
    location: location
  });
  return shouldTrack;
}

function updateViewCount(segmentData) {
  log("Updating view count");
  segmentData.pageViewCount = (segmentData.pageViewCount || 0) + 1;
  saveSegmentData(segmentData);
  log("New view count:", segmentData.pageViewCount);
  return segmentData.pageViewCount;
}

function identifyUser(segmentData) {
  log("Identifying user:", segmentData.email);
  analytics.identify(segmentData.email, {
    email: segmentData.email,
    name: segmentData.name,
    phone: segmentData.phone,
    sign_type_interested: segmentData.sign_type,
  });
}

// ========== Track Events ==========
function trackFormSubmitted(formData) {
  log("Form submitted, tracking in Segment");
  const segmentData = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    sign_type: formData.signType || "3d Acrylic Sign",
  };
  saveSegmentData(segmentData);
  identifyUser(segmentData);
  
  log("Sending 'Form Submitted' event to analytics");
  analytics.track("Form Submitted", {
    sign_type: segmentData.sign_type,
    logo_url: formData.logo_url || "",
    details: formData.details || "",
  });
}

function trackPaymentView(productId, productPrice) {
  log("Payment view tracking initiated");
  const segmentData = getSegmentData();
  const location = localStorage.getItem("countryName");
  if (shouldTrackView(segmentData, location)) {
    const viewCount = updateViewCount(segmentData);
    identifyUser(segmentData);
    
    log("Sending 'Payment Link Viewed' event to analytics");
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const viewedOnDevice = isMobile ? "mobile" : "desktop";

    analytics.track("Payment Link Viewed", {
      sign_type: segmentData.sign_type,
      payment_link_id: productId,
      shopify_url: window.location.href,
      price: productPrice,
      viewed_on_device: viewedOnDevice,
      view_count: viewCount,
    });
  }
}
